import { useDocumentTitle } from '../hooks/useDocumentTitle'
import { memeDetailDocumentTitle, useMemeDetailScreen } from '../hooks/useMemeDetailScreen'
import { MemeDetailScreen } from '../screens/MemeDetailScreen'
import { useParams } from 'react-router-dom'

function MemeDetailRouteScreen() {
  return <MemeDetailScreen {...useMemeDetailScreen()} />
}

export function MemeDetailView() {
  /* the route's name, not the record's: the card's own title arrives after the fetch, and a title
     that changes once the page is already announced is a page announced twice */
  useDocumentTitle(memeDetailDocumentTitle)
  const { id } = useParams<{ id: string }>()
  return <MemeDetailRouteScreen key={id} />
}
